export default __webpack_public_path__ + "static/media/portfolio3.58141922.jpg";